import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { AuthHttpService } from 'app/security/authorization';
import { UserService, User, ROLE } from 'app/user/';
import { noop } from 'app/shared';
import { LanguageService } from 'app/language/language.service';
import { LANGUAGE } from 'app/language/languages.const'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  private user: User = null;

  public LANGUAGE = LANGUAGE;

  constructor(
    private authHttp: AuthHttpService,
    private userService: UserService,
    private router: Router,
    private language: LanguageService
  ) {
    this.assignUser();
    userService.onUserChanged.subscribe(() => this.onUserChanged(), noop);
  }

  public logout() {
    this.authHttp.removeToken();
    this.userService.clearUser();
    this.router.navigate(['login']);
  }

  public getUserName(): string {
    if (null === this.user) {
      return '';
    }

    if (this.user.hasRole(ROLE.ADMIN) || this.user.hasRole(ROLE.SUPER_ADMIN)) {
      return 'Admin';
    }

    return this.user.fullName;
  }

  private assignUser(): void {
    this.userService.getUser()
    .then(
      (user: User): void => {
        this.user = user;
      }
    );
  }

  private onUserChanged(): void {
    this.assignUser();
  }

  public changeLanguage(language: LANGUAGE): void {
    this.language.setLanguage(language);
  }
}



// WEBPACK FOOTER //
// /dist/src/app/ui/header/header.component.ts